'use strict';

var $ = require('jquery');
var Backbone = require('backbone');

export default Backbone.View.extend({

  tagName: 'option',

  initialize: function (options) {
    this.option = options.option;
  },

  render: function () {
    this.$el.prop('value', this.option.value);
    this.$el.text(this.option.text);

    return this;
  },
});
